<template>
  <li>
    {{ sector.name }}
    <ul v-if="sector.children && sector.children.length">
      <SectorNode v-for="child in sector.children" :key="child.id" :sector="child" />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'SectorNode',
  props: ['sector'],
  components: {
    SectorNode: null
  },
  created() {
    this.$options.components.SectorNode = this.$options;
  }
};
</script>

